export default __webpack_public_path__ + "static/media/INMED AI STUDIO final-01 21.6db22282.png";